import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";

const ProtectedRoute = () => {
  const user = useSelector((state: RootState) => state.auth.user); // Get user from Redux

  return user ? <Outlet /> : <Navigate to="/login" replace />; // Redirect to login if not authenticated
};

export default ProtectedRoute;
